import { SectorEducationAPI } from './sector-education.api';
import { WorkAPI } from './work';

export class SectorsAPIPart {
  public static education = SectorEducationAPI;
  public static work = WorkAPI;
}
